const defaultState = {
	loading: true,
	id: -1,
	title: '',
	content: '',
	register: null,
	databases: '',
	introductionDate: null,
	publicationDate: null,
	abbreviation: '',
	sfsNumber: '',
	originalFileName: '',
	preparation: '',
	published: false,
	externalWeblink: '',
	registers: [],
	changeHistory: [],
	watchListEntries: [],
	activeTab: '1',
	showEmailDialog: false,
	emails: [],
	watchlistIds: [],
	watchlistSubject: '',
	watchlistChanged: '',
	watchlistContent: '',
	summary: '',
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case 'FETCH_SBL_BEGIN':
			return { ...defaultState, activeTab: state.activeTab || '1' };
		case 'FETCH_SBL_SUCCESS':
			return { ...state, loading: false, ...action.payload };
		case 'FETCH_REGISTERS_BEGIN':
			return { ...state, loading: true };
		case 'FETCH_REGISTERS_SUCCESS':
			return { ...state, registers: action.payload, loading: false };
		case 'EDIT_SBL':
			let result = { ...state };
			result[action.payload.attr] = action.payload.value;
			return result;
		case 'SBL_SAVE_BEGIN':
			return { ...state, loading: true };
		case 'SBL_SAVE_SUCCESS':
			return { ...state, loading: false };
		case 'SBL_DELETE_BEGIN':
			return { ...state, loading: false };
		case 'SBL_DELETE_SUCCESS':
			document.location.href = '/lagdel';
			return { ...state, loading: false };
		case 'SBL_CHANGE_TAB':
			return { ...state, activeTab: action.payload };
		case 'SBL_SHOW_EMAIL_DIALOG':
			return {
				...state,
				showEmailDialog: true,
				emails: action.payload.emails,
				watchlistIds: action.payload.ids,
				watchlistChanged: action.payload.lastChanged,
				watchlistSubject: action.payload.subject,
				watchlistContent: action.payload.content,
			};
		case 'SBL_HIDE_EMAIL_DIALOG':
			return { ...state, showEmailDialog: false, emails: [], watchlistIds: [] };
		case 'SBL_SUBMIT_EMAIL_NOTIFICATION_BEGIN':
			return { ...state, loading: true };
		case 'SBL_SUBMIT_EMAIL_NOTIFICATION_SUCCESS':
			return { ...state, loading: false, showEmailDialog: false };
		case 'SBL_CHANGE_WATCHLIST_INPUT':
			state[action.payload.attr] = action.payload.value;
			return { ...state };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/sbl/sblReducers.js